import { useState } from 'react';
import EmailIcon from '@material-ui/icons/Email';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CheckIcon from '@material-ui/icons/Check';
import { contact, about } from '../../portfolio';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Contact.css';

const Contact = () => {
  const [copied, setCopied] = useState(false);

  if (!contact.email) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(contact.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.location.href = `mailto:${contact.email}`;
    }
  };

  return (
    <section className='section contact center' id='contact'>
      <ScrollReveal>
        <h2 className='section__title'>Contact</h2>
      </ScrollReveal>

      <ScrollReveal delay={150}>
        <div className='contact__card glass-card'>
          <div className='contact__icon-wrap'>
            <EmailIcon className='contact__icon' />
          </div>
          <p className='contact__subtitle'>
            For PhD admissions conversations, research collaborations, or references, I would be glad to connect.
          </p>
          <a
            href={`mailto:${contact.email}`}
            className='contact__email link'
          >
            {contact.email}
          </a>

          <div className='contact__actions'>
            <a href={`mailto:${contact.email}`} className='btn btn--primary'>
              Send Email
            </a>
            <button
              type='button'
              className='btn btn--outline contact__copy-btn'
              onClick={handleCopy}
            >
              {copied ? (
                <>
                  <CheckIcon fontSize='small' /> Copied!
                </>
              ) : (
                <>
                  <FileCopyIcon fontSize='small' /> Copy Email
                </>
              )}
            </button>
          </div>

          {about.social?.linkedin && (
            <p className='contact__alt'>
              Or find me on{' '}
              <a
                href={about.social.linkedin}
                target='_blank'
                rel='noreferrer'
                className='link link-effect'
              >
                LinkedIn
              </a>
            </p>
          )}
        </div>
      </ScrollReveal>
    </section>
  );
};

export default Contact;
